export default __webpack_public_path__ + "static/media/DNo.20-7.40052b03.jpg";